import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { dueTodayTableConfig } from "../../../config/tables/superadmin/dueTodayTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface DueTodayTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function DueTodayTabComponent(props: DueTodayTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={dueTodayTableConfig}
      tabType="due-today"
    />
  );
}

export const DueTodayTab = memo(DueTodayTabComponent);
